import { Component } from '@angular/core';
import AppSettings from 'src/app/common/app.settings';
import { createLink } from 'src/app/components/profile/user-profile/view-profile/regular-user-profile/regular-user-profile-helper';
import { UserMarkerInfo } from 'src/app/interfaces/map.interface';
import { MarkerInfoState } from '../../shared/marker-info.state';

@Component({
  selector: 'app-user-marker',
  templateUrl: './user-marker.component.html',
  styleUrls: ['./user-marker.component.scss'],
})
export class UserMarkerComponent extends MarkerInfoState {
  public AppSettings: typeof AppSettings = AppSettings;

  public getLink(user: UserMarkerInfo): string {
    return createLink(user.status, user.userId, this.isAdminSession);
  }
}
